import PropTypes from 'prop-types'
import Post from './Post'

function Posts({ items }) {
  return (
    <div className="mt-8 grid gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {items.map((item) => (
        <Post key={item.id} {...item} />
      ))}
    </div>
  )
}

Posts.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
}

export default Posts
